// extracted by mini-css-extract-plugin
export default {"detailMain":"SupplierDetailPage_detailMain__O5mU3"};